import { initSection } from '../../core/shopify/init-section/index.js';
import Swiper, { Navigation, EffectCoverflow } from 'swiper';
const NAMESPACE = '.js-collections-slider-section';
initSection(NAMESPACE, (section)=>{
    const swiperEl = section.querySelector('.js-collections-slider');
    const nameEl = section.querySelector('.js-collections-slider-name');
    const ctaEl = section.querySelector('.js-collections-slider-cta');
    if (!swiperEl) return {
        unload: null
    };
    Swiper.use([
        Navigation,
        EffectCoverflow
    ]);
    const updateInfo = (slide)=>{
        if (!slide) return;
        var _slide_dataset_collectionName;
        const name = (_slide_dataset_collectionName = slide.dataset.collectionName) !== null && _slide_dataset_collectionName !== void 0 ? _slide_dataset_collectionName : '';
        var _slide_dataset_collectionUrl;
        const url = (_slide_dataset_collectionUrl = slide.dataset.collectionUrl) !== null && _slide_dataset_collectionUrl !== void 0 ? _slide_dataset_collectionUrl : '#';
        if (nameEl) nameEl.textContent = name;
        if (ctaEl) ctaEl.href = url;
    };
    const swiper = new Swiper(swiperEl, {
        centeredSlides: true,
        slidesPerView: 1.5,
        loop: true,
        effect: 'coverflow',
        coverflowEffect: {
            rotate: 0,
            stretch: 10,
            depth: 0,
            modifier: 1,
            scale: 0.8,
            slideShadows: false
        },
        breakpoints: {
            1024: {
                slidesPerView: 3
            }
        },
        navigation: {
            prevEl: section.querySelector('.js-collections-slider-prev'),
            nextEl: section.querySelector('.js-collections-slider-next')
        },
        on: {
            slideChange (sw) {
                updateInfo(sw.slides[sw.activeIndex]);
            },
            afterInit (sw) {
                updateInfo(sw.slides[sw.activeIndex]);
            }
        }
    });
    return {
        unload: ()=>{
            swiper.destroy(true, true);
        }
    };
});
